import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CardComponent } from './card.component';

@NgModule({
  imports: [CommonModule, NzIconModule],
  declarations: [CardComponent],
  exports: [CardComponent],
})
export class CardModule {}
